import { LocationsClient } from '@Clients/LocationsClient';
import { create } from 'zustand';
import { LocationStoreState } from '@models/LocationStoreState';

export const useLocationsStore = create<LocationStoreState>((set) => ({
  locations: [],
  locationHierarchy: [],
  loading: true,
  error: null,
  getLocationsByOrganizationId: async (organization_id, useLoading = true) => {
    if (useLoading) {
      set({ loading: true });
    }
    try {
      const locations = await LocationsClient.getLocationsByOrganizationId(
        organization_id
      );
      set({ locations });
    } catch (error) {
      set({ error: error as Error });
    } finally {
      set({ loading: false });
    }
  },
  getLocationHierarchy: async (organization_id, useLoading = true) => {
    if (useLoading) {
      set({ loading: true });
    }
    try {
      const hierarchy = await LocationsClient.getLocationHierarchy(
        organization_id
      );
      set({ locationHierarchy: hierarchy });
    } catch (error) {
      set({ error: error as Error });
    } finally {
      set({ loading: false });
    }
  },
  createLocation: async (location) => {
    set({ loading: true });
    try {
      const newLocation = await LocationsClient.createLocation(location);
      set((state) => ({
        ...state,
        locations: [...state.locations, newLocation],
      }));
    } catch (error) {
      set({ error: error as Error });
    } finally {
      set({ loading: false });
    }
  },
  updateLocation: async (location) => {
    set({ loading: true });
    try {
      const updatedLocation = await LocationsClient.updateLocation(location);
      set((state) => ({
        ...state,
        locations: state.locations.map((l) =>
          l.id === updatedLocation.id ? updatedLocation : l
        ),
      }));
    } catch (error) {
      set({ error: error as Error });
    } finally {
      set({ loading: false });
    }
  },
  deleteLocation: async (id) => {
    set({ loading: true });
    try {
      await LocationsClient.deleteLocation(id);
      set((state) => ({
        ...state,
        locations: state.locations.filter((l) => l.id !== id),
      }));
    } catch (error) {
      set({ error: error as Error });
    } finally {
      set({ loading: false });
    }
  },
}));
